module.exports = __webpack_public_path__ + "static/media/100k.6abb414b.jpg";